import React, { ReactNode } from 'react';
import { MorganaToggle, MorganaToggleOption } from './MorganaToggle';

interface SelectionPanelProps<T extends string> {
  title: string;
  titleColor: string;
  children: ReactNode;
  toggleOptions?: [MorganaToggleOption<T>, MorganaToggleOption<T>];
  toggleValue?: T;
  onToggleChange?: (value: T) => void;
  toggleColors?: { primary: string; textOnPrimary: string };
  containerId?: string;
}

export const SelectionPanel = <T extends string = string>({
  title,
  titleColor,
  children,
  toggleOptions,
  toggleValue,
  onToggleChange,
  toggleColors,
  containerId
}: SelectionPanelProps<T>) => {
  return (
    <aside id={containerId} aria-label={title}>
       <div className="flex justify-center items-center mb-1">
        <h3 
          className="m-0 text-[clamp(1.25rem,2.5vw,1.5rem)]" 
          style={{ color: titleColor }}
        >
          {title}
        </h3>
      </div>

      {toggleOptions && toggleValue && onToggleChange && (
        <MorganaToggle
          options={toggleOptions}
          value={toggleValue}
          onChange={onToggleChange}
          colors={toggleColors || { primary: 'white', textOnPrimary: 'black' }}
          containerStyle={{ marginBottom: 4 }}
        />
      )}

      <div className="morgana-list-container">
        {children}
      </div>
    </aside>
  );
};
